<template>
  <div>
    <v-sheet class="py-6 px-8">
      <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">미션 수정하기</p>

      <v-sheet class="mt-2 px-4">
        <v-text-field class="rounded-10" label="제목" dense outlined v-model="updateItem.title"></v-text-field>
        <v-select :items="status" class="rounded-10" label="활성화여부" dense outlined v-model="updateItem.status" style="max-width: 140px"></v-select>
        <!-- 본문 -->
        <TipTapWriter class="tiptap_style" :options="options" :key="componentKey" />
      </v-sheet>

      <v-sheet class="d-flex justify-center mt-5">
        <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
          <v-icon small left>mdi-cancel</v-icon>
          취소하기
        </v-btn>
        <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="updateSubmit()">
          <v-icon small left>mdi-database-edit-outline</v-icon>
          수정하기
        </v-btn>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import TipTapReader from "@/components/tiptap/Reader"
import { mapState } from "vuex"

export default {
  props: ["updateItem_import"],

  components: {
    TipTapWriter,
    TipTapReader,
  },
  computed: {
    ...mapState(["lafia_admin"]),
  },

  data: () => ({
    status: ["Y", "N"],
    updateItem: {},
    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    loadComplete: false,
    componentKey: 0,
  }),
  watch: {
    updateItem_import() {
      this.updateItem = this.updateItem_import
      if (this.updateItem_import.enabled) {
        this.updateItem.status = "Y"
      } else {
        this.updateItem.status = "N"
      }
      this.load()
    },
  },
  mounted() {
    this.updateItem = this.updateItem_import
    if (this.updateItem_import.enabled) {
      this.updateItem.status = "Y"
    } else {
      this.updateItem.status = "N"
    }
    this.load()
  },
  methods: {
    load() {
      this.$http
        .post("/api/missions/select/id", {
          params: {
            id: this.updateItem.id,
          },
        })
        .then(async (res) => {
          console.log(res.data)
          this.loadComplete = true
          if (res.data && res.data.length > 0 && res.data[0].content) {
            this.options.content = res.data[0].content
            this.componentKey++
          }
        })
    },
    updateSubmit: _.debounce(async function () {
      if (!this.loadComplete) {
        alert("미션 내용을 읽어오지 못했습니다. 새로고침후 다시 진행해 주세요.")
        return
      }

      // 제목 검증
      if (this.updateItem.title == "") {
        alert("제목을 입력해주세요")
        return
      }

      // 컨셉소개 내용 검증
      if (this.options.content == "") {
        alert("컨셉소개 내용을 입력해주세요")
        return
      }

      console.log(this.options.content)

      this.$http
        .post("/api/missions/update", {
          title: this.updateItem.title,
          content: this.options.content,
          admin_id: this.lafia_admin.user_id,
          enabled: this.updateItem.status === "Y" ? 1 : 0,
          id: this.updateItem.id,
        })
        .then((res) => {
          if (res.data.affectedRows) {
            alert("미션이 정상적으로 수정되었습니다")
            this.$emit("close")
          }
        })
    }, 500),
  },
}
</script>
<style></style>
